export default {
    setItem: (state, item) => { state.item = item },
    setClickedReferences: (state, clickedReferences) => { state.clickedReferences = clickedReferences },
    setItemContent: (state, itemContent) => { state.itemContent = itemContent },
    setClinicalHandouts: (state, clinicalHandouts) => { state.clinicalHandouts = clinicalHandouts },
    setConversations: (state, conversations) => { state.conversations = conversations },
    appendConversations: (state, conversations) => { state.conversations.push(...conversations) },
    setConversation: (state, conversation) => { state.conversation = conversation },
    setConversationsNextCursor: (state, cursor) => { state.conversationsNextCursor = cursor },
    clearConversation: (state) => { state.conversation = null },
    removeConversation: (state, id) => {
        state.conversations = state.conversations.filter(c => c.conversationId !== id);
    },
}